import React, { useEffect } from "react";

/**
 * PayPalReturnPage
 *
 * This page is opened as a new tab by the PayPal SDK during checkout.
 * Once PayPal redirects back here after approval, we notify the opener
 * window (the PricingPage) via postMessage and then close this tab.
 */
const PayPalReturnPage: React.FC = () => {
  useEffect(() => {
    // Give the page a brief moment to render, then close the tab
    const closeTimer = setTimeout(() => {
      // Notify the parent window if it's still open
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage({ type: "PAYPAL_APPROVED" }, "*");
      }
      window.close();
    }, 800);

    return () => clearTimeout(closeTimer);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "linear-gradient(135deg, #1a1a2e, #16213e)",
        color: "white",
        fontFamily: "Inter, sans-serif",
        gap: "1rem",
      }}
    >
      <div
        style={{
          background: "rgba(255,255,255,0.05)",
          border: "1px solid rgba(255,255,255,0.15)",
          borderRadius: "20px",
          padding: "3rem",
          textAlign: "center",
          backdropFilter: "blur(10px)",
        }}
      >
        <div style={{ fontSize: "4rem", marginBottom: "1rem" }}>✅</div>
        <h2 style={{ margin: 0, fontSize: "1.6rem", fontWeight: 700 }}>
          ¡Pago aprobado!
        </h2>
        <p style={{ color: "rgba(255,255,255,0.6)", margin: "0.5rem 0 0" }}>
          Procesando tu suscripción... Esta ventana se cerrará automáticamente.
        </p>
        <div
          style={{
            marginTop: "1.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.5rem",
            color: "rgba(255,255,255,0.4)",
            fontSize: "0.9rem",
          }}
        >
          <div
            className="spinner-border spinner-border-sm"
            style={{ color: "rgba(255,255,255,0.4)" }}
            role="status"
          ></div>
          Cerrando ventana...
        </div>
      </div>
    </div>
  );
};

export default PayPalReturnPage;
